export { ArrowRight as default } from './ArrowRight';
